<template>
  <tr>
    <td>{{ action.name }}</td>
    <td class="website-actions-table-col2 rf-custom-web-card-wrapper">
      <component
        :is="codeEditor.CodeEditor"
        :modelValue="displayCodeSummary(action)"
        v-bind="{ ...codeEditor.props, lineNums: false }"
        readOnly
      ></component>
    </td>
    <td v-if="userStore.isCurrentSuperAdmin">
      <v-checkbox v-model="action.internal" class="mt-0" hideDetails />
    </td>
    <td v-if="!isTrigger">
      <ul v-if="actionPrompts.length" class="list-deleted-trigger">
        <li v-for="prompt in actionPrompts.slice(0, showPromptEntries)" :key="prompt.id">
          <router-link :to="getPromptLink(prompt.id, $route.params.aid)">{{
            prompt.name
          }}</router-link>
        </li>
        <template v-if="actionPrompts.length > 3">
          <template v-if="showPromptEntries < actionPrompts.length">
            <li>...</li>
            <button class="text-blue-50" @click="showPromptEntries = actionPrompts.length">
              Show more
            </button>
          </template>
          <template v-else-if="showPromptEntries === actionPrompts.length">
            <button class="text-blue-50" @click="showPromptEntries = 3">Show less</button>
          </template>
        </template>
      </ul>
      <span v-else>N/A</span>
    </td>
    <td v-if="!isWebsiteAction">
      <ul v-if="actionTriggers.length" class="list-deleted-trigger">
        <li v-for="trigger in actionTriggers.slice(0, showTriggerEntries)" :key="trigger.id">
          {{ trigger.name }}
        </li>
        <template v-if="actionTriggers.length > 3">
          <template v-if="showTriggerEntries < actionTriggers.length">
            <li>...</li>
            <button class="text-blue-50" @click="showTriggerEntries = actionTriggers.length">
              Show more
            </button>
          </template>
          <template v-else-if="showTriggerEntries === actionTriggers.length">
            <button class="text-blue-50" @click="showTriggerEntries = 3">Show less</button>
          </template>
        </template>
      </ul>
      <span v-else>N/A</span>
    </td>
    <td class="cc-colm">
      <div class="settings-triggers-tbl-btn">
        <RfButton
          :icon="!!userStore.isDisabledWithMessage ? 'mdi:mdi-information-variant' : 'md:edit'"
          variant="plain"
          density="compact"
          color="accent"
          @click="$emit('edit')"
        />
        <RfButton
          icon="md:clear"
          color="error"
          variant="plain"
          density="compact"
          :disabled="userStore.isDisabledWithMessage"
          @click="$emit('remove')"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import { getPromptLink } from "@/utils/getLink";
import { useUserStore } from "@/pinia/userStore";
import RfButton from "../buttons/RfButton.vue";
import { useCodeEditor } from "@/utils/composables/useCodeEditor";

export default {
  components: { RfButton },
  props: [
    "action",
    "defaultCode",
    "actions",
    "retentions",
    "triggers",
    "isWebsiteAction",
    "isTrigger",
  ],
  setup: () => ({ getPromptLink, userStore: useUserStore(), codeEditor: useCodeEditor() }),
  data: () => ({ showPromptEntries: 3, showTriggerEntries: 3 }),
  computed: {
    actionPrompts() {
      return this.retentions.filter(
        prompt =>
          !!prompt.action_group_connector_actions.find(
            agca => agca.connector_action?.id === this.action.id,
          ),
      );
    },
    actionTriggers() {
      return this.triggers.filter(trigger => trigger.custom_trigger_id === this.action.id);
    },
  },
  methods: {
    displayCodeSummary(action) {
      if (action && action.code) {
        const codeWithoutComments = action.code.replace(this.defaultCode, "");
        let truncatedLines = codeWithoutComments.split("\n");
        if (truncatedLines.length > 3) {
          truncatedLines = truncatedLines.slice(0, 2);
          truncatedLines.push("...");
        }
        return truncatedLines.join("\n");
      }
      return "";
    },
  },
};
</script>
